import type { ModeFrais, ModelDemande, NatureFrais } from '@/features/domaine/types/opco'
import { NaturesFrais as NaturesFraisAF } from '@/features/domaine/types/opco/Demande/AF'
import { NaturesFrais as NaturesFraisCPRO } from '@/features/domaine/types/opco/Demande/CPRO'
import { NaturesFrais as NaturesFraisCXPI } from '@/features/domaine/types/opco/Demande/CXPI'
import { NaturesFrais as NaturesFraisDR } from '@/features/domaine/types/opco/Demande/DR'
import { NaturesFrais as NaturesFraisOutilFPE } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { NaturesFrais as NaturesFraisPROA } from '@/features/domaine/types/opco/Demande/PROA'

type ModeFraisNature = { [key in ModeFrais]: Readonly<NatureFrais[]> }

export const ModelDemandeFrais = {
  MODEL_CPRO: NaturesFraisCPRO,
  MODEL_AF: NaturesFraisAF,
  MODEL_CXPI: NaturesFraisCXPI,
  MODEL_CAPP: null,
  MODEL_DR: NaturesFraisDR,
  MODEL_PROFORMA: null,
  MODEL_PROA: NaturesFraisPROA,
  MODEL_OUTIL_FPE: NaturesFraisOutilFPE,
  MODEL_CAR: null,
} as const satisfies Record<ModelDemande, ModeFraisNature | null>
